import { Link } from 'react-router-dom';
import { MAPS_URL } from '@/lib/businessInfo';

export default function ServiceAreasHero() {
  return (
    <section className="relative bg-gradient-to-br from-[#1A2332] via-[#2C3E55] to-[#1A2332] text-white py-16 sm:py-20 overflow-hidden">
      <div className="absolute inset-0 bg-[url('https://public.readdy.ai/ai/img_res/65440d6956821042b7237e903d8189fb.jpg')] bg-cover bg-center opacity-10"></div>
      
      <div className="container mx-auto px-4 sm:px-6 relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          <div className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm border border-white/20 rounded-full px-4 py-2 mb-6">
            <i className="ri-map-pin-line text-[#E8B84B] shrink-0"></i>
            <span className="text-sm font-medium">Serving the Pacific Northwest</span>
          </div>

          <h1 className="font-oswald text-3xl sm:text-5xl md:text-6xl font-bold mb-6 leading-tight">
            We Deliver Quality Used Cars{' '}
            <span className="text-[#E8B84B]">Throughout Oregon &amp; Washington</span>
          </h1>

          <p className="text-base sm:text-xl text-white/90 mb-8 leading-relaxed">
            From Portland to Seattle, we bring honest, transparent car buying to communities 
            across the Pacific Northwest. Free delivery available to most areas.
          </p>

          <div className="flex flex-col sm:flex-row justify-center gap-3 sm:gap-4">
            <Link
              to="/inventory"
              className="inline-flex items-center justify-center gap-2 bg-[#E8B84B] text-[#1A2332] px-8 py-4 rounded-lg font-semibold hover:bg-[#D4A43A] transition-colors whitespace-nowrap w-full sm:w-auto"
            >
              <i className="ri-car-line text-xl shrink-0"></i>
              View Inventory
            </Link>
            <a
              href={MAPS_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center gap-2 bg-[#E8B84B] text-[#1A2332] px-8 py-4 rounded-lg font-semibold hover:bg-[#D4A43A] transition-colors whitespace-nowrap w-full sm:w-auto"
            >
              <i className="ri-map-pin-line text-xl shrink-0"></i>
              Get Directions
            </a>
            <Link
              to="/contact"
              className="inline-flex items-center justify-center gap-2 bg-white/10 backdrop-blur-sm text-white border border-white/30 px-8 py-4 rounded-lg font-semibold hover:bg-white/20 transition-colors whitespace-nowrap w-full sm:w-auto"
            >
              <i className="ri-phone-line text-xl shrink-0"></i>
              Contact Us
            </Link>
          </div>

          {/* Trust Indicators */}
          <div className="flex flex-wrap justify-center gap-4 sm:gap-6 mt-10 sm:mt-12">
            <div className="flex items-center gap-2 text-sm">
              <i className="ri-truck-line text-[#4ADE80] text-xl shrink-0" aria-hidden="true"></i>
              <span>Free Delivery Available</span>
            </div>
            <div className="flex items-center gap-2 text-sm">
              <i className="ri-shield-check-line text-[#4ADE80] text-xl shrink-0" aria-hidden="true"></i>
              <span>No-Pressure Sales</span>
            </div>
            <div className="flex items-center gap-2 text-sm">
              <i className="ri-heart-line text-[#4ADE80] text-xl shrink-0" aria-hidden="true"></i>
              <span>Supporting Local Rescues</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export { ServiceAreasHero };